<template>
    <vPersonExperienceComponent :postList="postList" v-if="flag"></vPersonExperienceComponent>
</template>
<script>
import vPersonExperienceComponent from '../../listComponent/basicdata/personExperience/personExperienceComponent.vue';
export default {
    name: 'personExperience',
    components: {
        vPersonExperienceComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                person_rid: true,
                classification: true,
                type: true,
                educational: true,
                entity: true,
                date: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>